const incidentLocations = (() => {
  let locationTable, locationData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function showAlreadyExistsWarning(msg, form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  // Incident Locations
  //-------------------------------------------------------------------------------

  function getIncidentLocationView() {
    const frag = document.createDocumentFragment();

    locationTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Location'],
      endIcon: true,
    });

    const headers = locationTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addLocationBtnDiv = document.createElement('div');
    const addLocationBtn = new Button({
      text: 'ADD NEW LOCATION',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(locationTable);
    if ($.session.SetupInsert) {
      addLocationBtn.button.style.float = 'right';
      addLocationBtn.renderTo(addLocationBtnDiv);
      frag.append(addLocationBtnDiv);
    }

    const tableLocationData = locationData
      .map(p => {
        return {
          id: p.locationId,
          values: [p.locationName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showLocationPopup(p);
          },
          endIconCallback: () => handleLocationDelete(p),
        };
      });

    table.populate(locationTable, tableLocationData);
    table.sortTableByHeader(locationTable);

    addLocationBtn.onClick(e => {
      showLocationPopup();
    });

    return frag;
  }

  // Incident Locations
  //-------------------------------------------------------------------------------

  function showLocationPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const locationForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Location',
          id: 'cName',
          required: true,
        },
      ],
    });

    locationForm.onKeyup(() => {
      locationForm.inputs['cName'].setValidtyError('');
      locationForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(locationForm);
    });
    locationForm.onChange(event => {
      locationForm.inputs['cName'].setValidtyError('');
      locationForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(locationForm);
    });

    locationForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentLocationData', {
          id: rowData ? rowData.locationId : 0,
          locationName: formdata.cName.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentLocationDataResult;
      const newID = resp.locationId;
      if (newID == '-1') {
        showAlreadyExistsWarning('This location already exists.', locationForm);
        locationForm.buttons['submit'].toggleDisabled(true);
        locationForm.buttons['cancel'].toggleDisabled(true);
      } else {
        locationForm.clear();
        POPUP.hide(popup);
        await getLocationData();
        updateLocationTable();
      }
    });

    locationForm.onCancel(event => {
      locationForm.clear();
      locationForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    locationForm.renderTo(popup);

    POPUP.show(popup);

    locationForm.populate({
      cName: rowData ? rowData.locationName : '',
    });

    locationForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      locationForm.disableFormInputs();
    }
  }

  async function handleLocationDelete(row) {
    const rowData = locationData.find(a => a.locationId == row.locationId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This location is used somewhere else in the system. It cannot be deleted.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this location?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentLocationData', {
            token: $.session.Token,
            locationId: row.locationId,
          });

          await getLocationData();
          updateLocationTable();
        }
      });
    }
  }
  function updateLocationTable() {
    const tableLocationData = locationData
      .map(p => {
        return {
          id: p.locationId,
          values: [p.locationName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showLocationPopup(p);
          },
          endIconCallback: () => handleLocationDelete(p),
        };
      });

    table.populate(locationTable, tableLocationData);
  }

  async function getLocationData() {
    const dataLocation = await _UTIL.fetchData('getIncidentLocation');
    locationData = dataLocation.getIncidentLocationResult;
  }


  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await getLocationData();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Locations';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Locations') {
      viewMarkup = getIncidentLocationView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
